module.exports = __webpack_public_path__ + "static/img_04-72cad35169624384cf5fef783185e6fd.png";